import { formatTime, formatDate } from '../../filter'
import moment from 'moment'

// 约定的数据字段结构
/**
 * 获取编辑数据
 * @returns {
    key: string; // 字段名称
    label: string; // 字段显示名
    value: string; // 字段当前值。枚举值时用英文逗号分隔。已经设值和默认值都可通过当前字段实现。当字段类型为下拉列表等时，要映射到枚举值的展示值
    type: string; // 字段类型
    notNull: string; // 是否必填。0-非必填，1-必填
    enumCode: string; // enumCode":"对应枚举code。当type为下拉列表/选框时用
    length?: number; // 字段长度限制。当type为文本输入框时用
    maxValue?: number; // 最大值。type为数字时用
    minValue?: number; // 最小值。type为数字时用
    canEdit?: boolean; // 自定义的是否可编辑
    selectOption: any[]; // 自定义的下拉选项
    rules?: any[]; // 支持自定义校验规则
    spacialLabelWidth?: number; // 支持自定义label宽度
    symbol?: string; // 输入框后面的单位或符号
    button?: string; // 输入框后面的按钮
    btnFun?: Function; // 输入框后面的按钮
    labelSpan?: Function; // label的栅格比例
    wrapperSpan?: Function; // 内容的栅格比例
	formSpan?: number; // 表单的栅格比例
}
 */

export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this
	let isPAIC = this.isPAIC && this.isFirstVisit && !this.isCarInsurance
	if (!isPAIC) {
		return false
	}

	const hasMajorDisease = !(
		injured.majorDisease &&
		['0', ''].includes(injured.majorDisease.hasMajorDisease)
	)

	let majorDiseaseList = []
	if (injured.majorDisease && injured.majorDisease.majorDiseaseList.length) {
		majorDiseaseList = injured.majorDisease.majorDiseaseList
	}

	const modal = [
		{
			label: '重疾种类',
			value: '',
			key: 'diseaseType',
			selectOption: [],
			type: 'searchSelect',
			notNull: '1',
			canEdit: true,
			formSpan: 3,
		},
		{
			label: '重疾描述',
			value: '',
			key: 'diseaseDesc',
			type: 'text',
			notNull: '1',
			canEdit: true,
			formSpan: 4,
			rules: [
				{
					max: 200,
					message: '长度不能超过200位',
					trigger: 'blur',
				},
			],
		},
		{
			label: '确诊依据',
			value: '',
			key: 'diagnosisBasis',
			selectOption: [],
			type: 'select',
			notNull: '0',
			canEdit: true,
			formSpan: 3,
		},
		{
			label: '确诊时间',
			value: '',
			key: 'diagnosisDate',
			type: 'date',
			notNull: '0',
			canEdit: true,
			allowClear: false,
			formSpan: 4,
			disabledDate: current => {
				// 不能大于今天
				return current && current > moment().endOf('day')
			}, //禁止选择的时间区间
		},
		{
			label: '原发部位',
			value: '',
			key: 'primarySite',
			selectOption: setting.primarysiteList,
			type: 'select',
			notNull: '0',
			canEdit: true,
			formSpan: 3,
		},
		{
			label: '原发部位描述',
			value: '',
			key: 'primarySiteDesc',
			type: 'text',
			notNull: '0',
			canEdit: true,
			formSpan: 4,
			rules: [
				{
					max: 200,
					message: '长度不能超过200位',
					trigger: 'blur',
				},
			],
		},
		{
			label: '确诊依据',
			value: '',
			key: 'diagnosisBasisDesc',
			selectOption: [],
			type: 'hide',
			notNull: '0',
			canEdit: true,
			formSpan: 3,
		},
	]

	const list = majorDiseaseList.map((item, index) => {
		let diagnosisDate = item.diagnosisDate
			? moment(formatDate(item.diagnosisDate), 'YYYY-MM-DD')
			: ''
		const valArr = [
			item.diseaseType,
			item.diseaseDesc,
			item.diagnosisBasis,
			diagnosisDate,
			item.primarySite,
			item.primarySiteDesc,
			item.diagnosisBasisDesc,
		]

		let arr = modal.map((moadlItem, valIndex) => {
			let obj = {
				...moadlItem,
				value: valArr[valIndex],
			}
			// 组装重疾种类列表数据
			if (obj.key == 'diseaseType') {
				obj.selectOption = [
					{
						key: item.diseaseType,
						value: item.diseaseTypeDesc,
					},
				]
			}
			// 组装确诊依据列表数据
			if (obj.key == 'diagnosisBasis') {
				obj.selectOption = [
					{
						key: item.diagnosisBasis,
						value: item.diagnosisBasisDesc,
					},
				]
			}

			return obj
		})

		return {
			list: arr,
		}
	})

	const obj = {
		title: '重疾信息',
		key: 'majorDisease.majorDiseaseList', // 提交时对应的字段
		modal: modal, // 每一行的模板
		children: list, // 数据列表
		majorDisease: {
			hasMajorDisease: hasMajorDisease,
		},
	}

	return obj
}
